module.exports = __webpack_public_path__ + "img/@ico_hand.a4a2dc56.jpg";